<vcl-modal id="termsModal" *ngIf="declaration" [(showModal)]="showModal" [buttonLabels]="buttonLabelsModal" (modalButtonClick)="modalAction($event)">
    <h2 class="title-modal-insurability">{{declaration.title}}</h2>
    <p id="pdfText" [innerHtml]="declaration.text"></p>
</vcl-modal>
<div class="content-with-stepper-and-title">
    <main class="field col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 px-0">
      <div class="space"></div>
      <h2 class="title offset-inline" id="generalTitle">
        {{copyService.copies.insurability_title}}
      </h2>
      <div class="space"></div>
      <h3 class="sub-title offset-inline" id="subgeneralTitle">
        {{copyService.copies.insurability_sub1}}
      </h3>
      <br>
      <div class="content">
        <voxel-radio-button-group id="isDecAsegurability" class="radio-margin">
            <voxel-radio-button *ngFor="let selectionList of listIsInsurability" [id]="'radioButtonID' + selectionList.label" radioName="dec" [checked]="selectionList.checked" (change)="selectDecInsurability($event)" [value]="selectionList.value">{{selectionList.label}}</voxel-radio-button>
        </voxel-radio-button-group>
      </div>
      <div class="space"></div>
      <div *ngIf="documentDec" class="field col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 px-0">
        <div class="group-3">
            <p class="texto-copy">
              {{copyService.copies.insurability_description}}
             </p>
             <vcl-link [link-text-only]="'backDocDeclarationLink'" (click)="downloadPdf()" [label]="copyService.copies.insurability_link_label1">
            </vcl-link>
          </div>
          <br>
            <voxel-checkbox [id]="'backDocCheckboxDeclaration'" [checked]="checkboxDeclaration.checked" name="declaration" [value]="checkboxDeclaration.value" (checkboxChange)="checkboxChange($event)">
            </voxel-checkbox>  
            <div class="link">
              <p class="texto-copy">
                {{checkboxDeclaration.label}}      
              </p>
              <vcl-link [linkId]="'backDocDeclarationLink'" (click)="toggleModal()" [label]="copyService.copies.insurability_link_label">
              </vcl-link>
            </div>
    </div>
    </main>
    <app-controls [hasPrevious]="true" [nextLabel]="copyService.copies.insurability_summary_button" [nextDisabled]="isBtnDisabled" (only_previous)="sendBackButtonEvent()" (next)="next()"></app-controls>
  </div>
  